export { ChangeScreenOrientationPage } from './change_screen_orientation';
export type { ChangeScreenOrientationPageProps } from './change_screen_orientation';
